import React from 'react';

import AemEditableText from '@/components/Aem/AemEditableText/AemEditableText';
import routePaths from '@/consts/route/routePaths';
import appIntlUtils from '@/services/appIntlUtils';
import {twx} from '@/utils/tailwindUtils';

import AutoDeliveryEditAddressButton from './AutoDeliveryEditAddressButton';

const getFullAddress = ({address1, address2, city, postalCode}) => {
    return `${address2} ${address1}, ${postalCode} ${city},`;
};

const AutoDeliveryOrderAddress = ({className, address, isEditAllowed}) => {
    const fullAddress = getFullAddress(address);
    const countryName = appIntlUtils.getCountryNameByCountryCode(address.countryCode);

    return (
        <div className={twx('px-4 py-8', className)}>
            <div className='flex items-center justify-between gap-2'>
                <h2 className='mb-0 overflow-hidden text-ellipsis whitespace-nowrap text-24 font-bold leading-13'>
                    <AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='addressTitle' />
                </h2>
                {isEditAllowed && <AutoDeliveryEditAddressButton />}
            </div>
            <h3 className='mb-3 mt-6 text-18 font-bold leading-155 tracking-02 md:mb-1'>
                <AemEditableText pageName={routePaths.AUTO_DELIVERY} itemName='homeAddressTitle' />
            </h3>
            <p>{fullAddress}</p>
            <p>{countryName}</p>
        </div>
    );
};

export default AutoDeliveryOrderAddress;
